<div>
	<div class="d-flex justify-content-between mb-2 px-2">
		<h2>{{'connectivity_verification.connectivity_verification_header' | translate}}</h2>
	</div>
	<nav class="navbar navbar-expand-lg border-radius-top navbar-light bg-white topnav pt-2 pb-0 px-4 nav-border main-black">
		<ul class="navbar-nav mr-auto">
			<li class="nav-item">
				<a class="nav-link p-3 light-grey small pointer"
					[ngClass]="{'active': activeTable == 'connectivity_verification_statistics'}"
					(click)="setActiveTable('connectivity_verification_statistics')"
				>
					<h5> {{'connectivity_verification.devices_and_sites' | translate}}</h5>
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link p-3 light-grey small pointer"
					[ngClass]="{'active': activeTable == 'hardware_errors_statistics'}"
					(click)="setActiveTable('hardware_errors_statistics')"
				>
					<h5> {{'connectivity_verification.hardware_errors' | translate}}</h5>
				</a>
			</li>
		</ul>
	</nav>
	<sct-custom-table
		*ngIf="activeTable == 'connectivity_verification_statistics'"
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
	<sct-custom-table
		*ngIf="activeTable == 'hardware_errors_statistics'"
		[columnsConfig]="hardwareErrorsColumnConfig"
		[data]="hardwareErrorsTableData"
		[config]="hardwareErrorsTableConfig"
	></sct-custom-table>
</div>

<app-modal [title]="modalTitle" #devicesInfoModel  [hasConfirmButton]="false" [hasCloseButton]="false" size="xl">
	<div class="d-flex justify-content-end">
		<button class="btn btn-primary mb-2" (click)="exportUniqueDevicesFile()">{{'g.export' | translate}}</button>
	</div>
	<table class="table table-striped">
		<thead>
			<tr class="text-center">
				<th>{{'g.devices' | translate}}</th>
			</tr>
		</thead>
		<tbody>
			<tr class="text-center" *ngFor="let macAddress of devicesData">
				<td>
					<a [routerLink]="!devicesInfo[macAddress]?.site_id ? null : ['/', sitesInfo[devicesInfo[macAddress]?.site_id]?.customer_id, devicesInfo[macAddress]?.site_id, macAddress, 'performance']">
						{{(!devicesInfo[macAddress]?.site_id  ? macAddress : devicesInfo[macAddress]?.serial_number)}}
					</a>
				</td>
			</tr>
		</tbody>
	</table>
</app-modal>

<app-modal [title]="modalTitle" #waningDevicesInfoModel  [hasConfirmButton]="false" [hasCloseButton]="false" size="xl">
	<div class="d-flex justify-content-end">
		<button class="btn btn-primary mb-2" (click)="exportWaningDevicesFile()">{{'g.export' | translate}}</button>
	</div>
	<table class="table table-striped">
		<thead>
			<tr class="text-center">
				<th>{{'g.devices' | translate}}</th>
			</tr>
		</thead>
		<tbody>
			<tr class="text-center" *ngFor="let mac_address of waningDevicesData">
				<td *ngIf="devicesInfo[mac_address]">
					<a [routerLink]="devicesInfo[mac_address].serial_number == 'device_deleted'? null: ['/', sitesInfo[devicesInfo[mac_address]?.site_id]?.customer_id, devicesInfo[mac_address].site_id, mac_address, 'performance']">
						{{(devicesInfo[mac_address].serial_number == 'device_deleted'? mac_address : devicesInfo[mac_address].serial_number)}}
					</a>
				</td>
			</tr>
		</tbody>
	</table>
</app-modal>

<app-modal [title]="modalTitle" #sitesInfoModel  [hasConfirmButton]="false" [hasCloseButton]="false" size="xl">
	<div class="d-flex justify-content-end">
		<button class="btn btn-primary mb-2" (click)="exportUniqueSitesInfo()">{{'g.export' | translate}}</button>
	</div>
	<table class="table table-striped">
		<thead>
			<tr class="text-center">
				<th>{{'site.sites' | translate}}</th>
			</tr>
		</thead>
		<tbody>
			<tr class="text-center" *ngFor="let site of sitesData">
				<td>
					<a [routerLink]="!sitesInfo[site]?.name ? null : ['/', sitesInfo[site]?.customer_id, site]">
						{{(!sitesInfo[site]?.name ? "connectivity_verification.site_deleted" : sitesInfo[site]?.customer_name + ' | ' + sitesInfo[site]?.name ) | translate}}
					</a>
				</td>
			</tr>
		</tbody>
	</table>
</app-modal>
